import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { SnackbarModule } from "../../shared/components/snackbar/snackbar.module";
import { SuperUserAdvancedSearchComponent } from "./super-user-advanced-search.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButtonModule,
    MatInputModule,
    MatCardModule,
    SnackbarModule
  ],
  declarations: [SuperUserAdvancedSearchComponent],
  exports: [SuperUserAdvancedSearchComponent]
})
export class SuperUserAdvancedSearchModule {}
